<script lang="ts">
    import { Table } from "attractions";
    import Purchase from "../../../Models/Purchase";
    import PhoneIcon from "../../../Icons/mobile.svg";
    import ClearanceActions from "./ClearanceActions.svelte";
    import { LATEST_PURCHASE_WITH_CLEARANCE_ACTION } from "../../../Stores/Purchase";
    import Currency from "../../../Utils/Currency";

    export let counter = 0;
    export let sum = 0;

    const headers = [
        { text: 'Data', value: 'date' },
        { text: 'Produkt', value: 'product' },
        { text: "Pracownik", value: 'employee' },
        { text: 'Cena', value: 'price' },
        { text: 'Akcje', value: 'actions' }
    ];

    let items, purchases;

    LATEST_PURCHASE_WITH_CLEARANCE_ACTION.subscribe(async () => {
        const res = await Purchase.get(true);
        if (res) {
            sum = 0;
            counter = 0;
            res.forEach(purchase => {
                sum += purchase.price;
                counter++;
            });
            purchases = res.map(purchase => {
                const { _id, date, employee, price, product } = purchase;
                return {
                    _id,
                    date: new Date(date).toLocaleDateString('pl', { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric" }),
                    employee,
                    price,
                    product: product.name
                }
            })
            items = purchases.reverse();
        }
    });
</script>

{#if purchases && purchases.length}
    <Table {headers} {items} >
        <div let:header let:item slot="item">
            {#if header.value == 'employee'}
                {item['employee']['firstname']} {item['employee']['lastname']}
                <a class="icon-12" href="tel:{item['employee']['phone']}">{@html PhoneIcon}</a>
            {:else if header.value == 'actions'}
                <ClearanceActions purchase={item['_id']} />
            {:else if header.value == 'price'}
                {Currency.format(item['price'])}
            {:else}
                {item[header.value]}
            {/if}
        </div>
    </Table>
{:else}
    <h3>Nie masz żadnych zakupów do rozliczenia.</h3>
{/if}